import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  OrganizationSubscriptionAlert,
  GetOrganizationSubscriptionAlertRequestProps
} from "./types";

export const getOrganizationSubscriptionAlertRequest = ({
  organizationId,
  subscriptionId
}: GetOrganizationSubscriptionAlertRequestProps) =>
  apiProxyRequest<OrganizationSubscriptionAlert>(
    `/organizations/${organizationId}/alerts/subscriptions/${subscriptionId}/usage`
  );
